import { useCallback } from 'react'
import type { Edge } from '@xyflow/react'
import type { PipelineNode } from '../types'
import { getLayoutedElements, getGridLayout, type LayoutOptions } from '../utils/layoutEngine'

export type LayoutMode = 'dagre' | 'grid'

export function usePipelineLayout() {
  const applyLayout = useCallback(
    (
      nodes: PipelineNode[],
      edges: Edge[],
      mode: LayoutMode = 'dagre',
      options?: LayoutOptions
    ) => {
      if (mode === 'grid') {
        return getGridLayout(nodes, edges)
      }
      return getLayoutedElements(nodes, edges, options)
    },
    []
  )

  return { applyLayout }
}
